import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { VendorDealerDialogComponent } from './vendor-dealer-dialog.component';

@NgModule({
  declarations: [VendorDealerDialogComponent],
  imports: [CommonModule, SharedModule],
  exports: [VendorDealerDialogComponent],
})
export class VendorDealerDialogModule {}
